import React from 'react';
import styled, { css } from 'styled-components';
import { SvgComponent } from '../../assets';
import { theme } from '../../theme';
import { UIText } from '../typography';

export type SwitchButtonType = {
  label: string;
  value: string;
  icon?: SvgComponent;
};

const ButtonBase = styled.button<{ isSelected: boolean }>`
  width: fit-content;
  height: 40px;
  border: 0;
  cursor: pointer;
  display: flex;
  padding: 0 ${theme.spacings[3].rem};
  justify-content: center;
  align-items: center;
  border-radius: ${theme.borderRadius.default};
  background-color: ${theme.colors.neutrals.solidGrays[7]};
  color: ${theme.colors.primary.graysGray};
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${theme.colors.primary.graysRed};
      color: ${theme.colors.primary.white};
    `};
`;

const StyledUIText = styled(UIText)<{ isSelected: boolean }>`
  display: inline-block;
  padding-left: ${theme.spacings[2].rem};

  ${({ isSelected }) =>
    isSelected &&
    css`
      color: ${theme.colors.primary.white};
      font-weight: bold;
    `};
`;

type SingleSwitchButtonProps = SwitchButtonType & {
  handleClick: (value: string) => void;
  isSelected: boolean;
};

export const SingleSwitchButton: React.FC<SingleSwitchButtonProps> = ({
  handleClick,
  label,
  value,
  isSelected,
  icon: Icon,
}) => {
  return (
    <ButtonBase onClick={() => handleClick(value)} isSelected={isSelected}>
      {Icon && (
        <Icon
          width={16}
          fill={
            isSelected
              ? theme.colors.primary.white
              : theme.colors.primary.graysGray
          }
        />
      )}
      <StyledUIText isSelected={isSelected} size="sm">
        {label}
      </StyledUIText>
    </ButtonBase>
  );
};
